import { fromFetch } from 'rxjs/fetch';
import { getResultFacets } from 'constants/routes'
import { switchMap } from 'rxjs';

function getBrands$(payload) {
  const url = `${getResultFacets}`;

  return fromFetch(url, {
    method: 'POST',
    body: JSON.stringify({
      searchCommand: {
        ...payload
      }
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }).pipe(
    switchMap((response) => response.json())
  );
}

export default getBrands$;
